import { DateOnly } from '@if/core/date'
import { EPaymentFrequency } from '@if/core/types'
import { nanoid } from 'nanoid'
import { EditPaymentSchemaType } from '../EditPayments-schema'
import { AddRecurringPaymentSchemaType } from './LoanAddRecurringPayment-schema'

const addNextPaymentWithFrequency = (
  currentPayment: EditPaymentSchemaType,
  frequency: EPaymentFrequency,
): EditPaymentSchemaType => {
  const newDate = new DateOnly(currentPayment.effectiveDate)
  switch (frequency) {
    case EPaymentFrequency.Weekly:
      newDate.setDate(newDate.getDate() + 7)
      break
    case EPaymentFrequency.BiWeekly:
      newDate.setDate(newDate.getDate() + 14)
      break
    case EPaymentFrequency.Monthly:
      newDate.setMonth(newDate.getMonth() + 1)
      break
  }
  return {
    ...currentPayment,
    id: nanoid(),
    effectiveDate: newDate,
  }
}

export const generateRecurringPaymentByNumberOfPayments = (
  firstPayment: EditPaymentSchemaType,
  frequency: EPaymentFrequency,
  numberOfPayments: number,
): EditPaymentSchemaType[] => {
  const payments: EditPaymentSchemaType[] = []
  let newPayment: EditPaymentSchemaType = firstPayment

  for (let i = 0; i < numberOfPayments; i++) {
    newPayment = addNextPaymentWithFrequency(newPayment, frequency)
    payments.push(newPayment)
  }

  return payments
}

export const generateRecurringPaymentByEndDate = (
  firstPayment: EditPaymentSchemaType,
  frequency: EPaymentFrequency,
  endDate: DateOnly,
): EditPaymentSchemaType[] => {
  const payments: EditPaymentSchemaType[] = []
  let newPayment: EditPaymentSchemaType = firstPayment

  while (newPayment.effectiveDate <= endDate) {
    newPayment = addNextPaymentWithFrequency(newPayment, frequency)
    payments.push(newPayment)
  }

  return payments
}

export const createFirstPaymentForRecurring = (paymentData: AddRecurringPaymentSchemaType): EditPaymentSchemaType => ({
  id: nanoid(),
  isNew: true,
  effectiveDate: paymentData.startDate,
  amount: paymentData.amount,
  note: paymentData.note,
  paymentMethod: paymentData.paymentMethod,
  sendSmsReminder: paymentData.sendSmsReminder,
  isLocked: false,
  isDeleted: false,
})
